import { useContext } from 'react';
import { FlexContext } from '../../../contexts/flexContext';
import { withClientContainer } from '../../../reducers/flexContextReducer';
import useFlexHttpCall, {
  IFlexHttpCall,
  IFlexHttpCallOptions,
} from '../../useFlexHttpCall';
import { IStructuredSnowplowEvent } from '../../useSnowplowTracker';
import { IFlexNavigation } from '../useFlexNavigation';
import { IFlexMemory } from '../../../views/flex/flexNode';

export interface IFlexNavigateReference {
  type: 'reference';
  call: IFlexHttpCall;
  destinationMemory?: IFlexMemory;
  snowplowEvent?: IStructuredSnowplowEvent;
}

const useFlexNavigateReference = () => {
  const handleFlexHttpCall = useFlexHttpCall();
  const flexContext = useContext(FlexContext);

  const handleFlexNavigateReference = (
    flexNavigate: IFlexNavigateReference
  ): Promise<IFlexNavigation> => {
    const options: IFlexHttpCallOptions = {};
    if (flexNavigate.destinationMemory && flexContext.node) {
      options.memoryOverride = withClientContainer(
        flexNavigate.destinationMemory,
        flexContext.node.id
      );
    }
    return handleFlexHttpCall<IFlexNavigation>(flexNavigate.call, options);
  };

  return handleFlexNavigateReference;
};

export default useFlexNavigateReference;
